import React from 'react';
import { useTranslation } from 'react-i18next';

import TextTooltip from '../../../TextTooltip';
import { StyledChevronIcon, ToggleButton, ToggleButtonContainer } from './ToggleButtonDrawer.styles';

const ToggleButtonDrawer = ({ isExpanded, onToggle }) => {
  const [tooltipDisabled, setTooltipDisabled] = React.useState(false);
  const { t } = useTranslation();
  const tooltipText = isExpanded ? t('common.collapse') : t('common.expand');

  React.useLayoutEffect(() => {
    setTooltipDisabled(true);
  }, [tooltipText]);

  return (
    <ToggleButtonContainer onMouseEnter={() => setTooltipDisabled(false)} onMouseLeave={() => setTooltipDisabled(true)}>
      <TextTooltip tooltipText={tooltipText} placement="right" isDisabled={tooltipDisabled}>
        <ToggleButton
          rounded={true}
          icon={<StyledChevronIcon $isOpen={isExpanded} />}
          onClick={onToggle}
        ></ToggleButton>
      </TextTooltip>
    </ToggleButtonContainer>
  );
};

export default ToggleButtonDrawer;
